/**
 * Hàm replace string chứa các ký tự html
 * @param str String
 * @returns new string before replace
 */
export default (str: string): string => {
  if (!str) {
    return str;
  }
  const entityMap: any = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#x2F;': '/',
    '&#x60;': '`',
    '&#x3D;': '=',
  };
  Object.keys(entityMap).forEach((key) => {
    str = str.replace(key, entityMap[key]);
  });
  return str;
};
